import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
export { MatDialogRef };

@Component({
  selector: 'modal-window',
  templateUrl: './modal-window-base.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowBaseComponent {
  protected _defaults = {
    dialog_data: {
        title: 'Mensaje del sistema',
        body: 'Mensaje de prueba',
        icon: 'info'
    }
  }
  public moda_window_ref: MatDialogRef<any>;

  // ===========================================================================
  // ---------------------------------------------------------------------------
  constructor(

  ) {
    this.moda_window_ref = inject(MatDialogRef<any>);
  }

  // ---------------------------------------------------------------------------
  close(): void {
    this.moda_window_ref.close();
  }

  // ---------------------------------------------------------------------------
  closeAndReturn(return_data: any): void {
    this.moda_window_ref.close(return_data);
  }


}
